var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content__module",class:_vm.ThemeGet},[_c('span',{staticClass:"light-text",class:_vm.ThemeGet},[_vm._v("StartPage")])])}
var staticRenderFns = []

export { render, staticRenderFns }